exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Q7PC{align-self:center}._2gYuq{max-width:100%}@media all and (-ms-high-contrast: none){._2gYuq{margin:10px 10px 0 10px;flex:1 0 auto}}\n", ""]);

// Exports
exports.locals = {
	"vertical": "_3Q7PC",
	"root": "_2gYuq"
};